import React, { useEffect, useState } from "react";
import banner1 from "../../assets/banner1.jpg";
import banner2 from "../../assets/banner2.jpg";
import banner3 from "../../assets/banner3.jpg";

const HeroSlider = () => {
  const [current, setCurrent] = useState(0);
  const [visibleSlides, setVisibleSlides] = useState([]);

  useEffect(() => {
    const updateSlides = () => {
      if (window.innerWidth < 768) {
        // 🔹 En pantallas chicas, solo banner1 y banner2 por separado
        setVisibleSlides([
          { type: "single", images: [{ src: banner1, alt: "Banner 1" }] },
          { type: "single", images: [{ src: banner2, alt: "Banner 2" }] },
        ]);
      } else {
        // 🔹 En pantallas grandes, banner1 y 2 juntos, luego banner3
        setVisibleSlides([
          {
            type: "double",
            images: [
              { src: banner1, alt: "Banner 1" },
              { src: banner2, alt: "Banner 2" },
            ],
          },
          {
            type: "single",
            images: [{ src: banner3, alt: "Banner 3" }],
          },
        ]);
      }
    };

    updateSlides();
    window.addEventListener("resize", updateSlides);
    return () => window.removeEventListener("resize", updateSlides);
  }, []);

  useEffect(() => {
    if (visibleSlides.length > 0) {
      const interval = setInterval(() => {
        setCurrent((prev) => (prev + 1) % visibleSlides.length);
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [visibleSlides]);

  if (visibleSlides.length === 0) return null;

  return (
    <div className="relative w-full max-w-7xl mx-auto h-[35vh] sm:h-[50vh] md:h-[60vh] overflow-hidden rounded-2xl shadow-lg mt-4 md:mt-10">
      {visibleSlides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 flex justify-center items-center transition-opacity duration-1000 ${
            index === current ? "opacity-100 z-10" : "opacity-0 z-0"
          }`}
        >
          {slide.type === "double" ? (
            // 🔹 En pantallas grandes mostramos los dos juntos
            <div className="hidden sm:grid sm:grid-cols-2 gap-2 w-full h-full">
              {slide.images.map((img, i) => (
                <img
                  key={i}
                  src={img.src}
                  alt={img.alt}
                  className="w-full h-full object-cover rounded-xl"
                />
              ))}
            </div>
          ) : (
            // 🔹 En pantallas chicas mostramos un banner por vez
            <img
              src={slide.images[0].src}
              alt={slide.images[0].alt}
              className="w-full h-full object-cover rounded-xl"
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default HeroSlider;
